export default __webpack_public_path__ + "static/media/PENNYBANK_SCHOLARSHIPS_2022.eb3085ae.png";